import { ApiResponse } from '../types/auth';
import { TelegramChatsListResponse, TelegramChatsRequest } from '../types/telegramChats';
import { ApiService } from './api';

export class TelegramChatsService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getTelegramChats(request: TelegramChatsRequest): Promise<ApiResponse<TelegramChatsListResponse>> {
    try {
      const params = new URLSearchParams({
        page: request.page.toString(),
        pageSize: request.pageSize.toString(),
      });

      const response = await this.apiService.get<TelegramChatsListResponse>(
        `/admin/telegram-chat-list?${params.toString()}`
      );

      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch telegram chats',
        success: false
      };
    }
  }
}

export const telegramChatsService = new TelegramChatsService();
